import './Header.scss';
import logo from '../../images/happy-connect-logo.png'; 

export default function Header() {
    return (
        <header className="header">
            <div className="container nav">

                {/* LEFT MENU */}
                <ul className="nav-left">
                    <li>HOME ▾</li>
                    <li>PROPERTIES ▾</li>
                    <li>DIGITAL MARKETING ▾</li>
                    {/* <li>PAGES ▾</li> */}
                    <li>CONTACT</li>
                </ul>

                {/* LOGO CENTER */}
                <div className="logo">
                    <img src={logo} alt="logo" />
                    {/* <span>Houzing</span> */}
                </div>

                {/* RIGHT SIDE */}
                <div className="nav-right">
                    <span className="phone">📞 +91 7204394684</span>
                    <span className="login">👤 Login / Register</span>
                    {/* <button className="btn">+ CREATE LISTING</button> */}
                </div>

            </div>
        </header>
    );
}